
<div class="container mb-4">
  <ng-container *appFeatureFlag="'isFreePetInsuranceCheckBoxAvailable'">
    <div class="d-flex justify-content-center">
      <div class="petplan-box-image">
        <img
          class="petplan-box-image-content"
          src="/assets/images/partner/petplan/dog/welcome-gift-banner.webp"
          alt="top-dog-pic"
        />
      </div>
    </div>
    <h4 class="petplan-box__header mb-0 mt-4 p-3 fw-bold">Get 4 weeks free pet insurance from Petplan</h4>

    <div class="petplan-box__content p-3">
      <div [innerHTML]="petPlanText1"></div>
      <div class="d-flex">
        <div>
          <input
          id="freePetInsurance"
          type="checkbox"
          [(ngModel)]="isPetPlanCheckboxChecked"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="checkValue($event)"
          />
        </div>
        <label for="freePetInsurance" class="form-label ms-2" [innerHTML]="petPlanCheckboxLabel"></label>
      </div>
    </div>

    <div class="petplan-box__footer p-3" [innerHTML]="petPlanText2"></div>

    <div class="d-flex flex-column align-items-center p-3">
      <button
        ngClass="btn-success"
        class="btn btn-lg my-4 text-white"
        [disabled]="loading || !isPetPlanCheckboxChecked"
        (click)="completeWelcomeGiftLite()"
      >
        <fa-icon
          *ngIf="loading"
          [icon]="['fas', 'spinner']"
          [animation]="'spin'"
          class="me-2"
        ></fa-icon>
        {{ loading ? "Activating" : "Activate Free Cover" }}
      </button>
  </div>

  </ng-container>
</div>
